<template>
    <div class="Background">
        <div style="display: flex; justify-content: space-between;">
            <!-- <h2 class="Title">
                레코딩 파일
            </h2> -->
            <div class="link_location">
                <h2 class="Title">
                    {{ $store.getters.t('라이브') }}
                    <v-icon class="mdi mdi-chevron-right" />
                    <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('HLS 레코딩') }}</span>
                    </h2>
            </div>

            <!-- <div class="link_location">
                라이브 <v-icon small class="mdi mdi-chevron-right" />
                <a href="/wowzastream/wowzalivestream_recording">레코딩 파일</a>
            </div> -->
        </div>

            <WowzaLivestreamRecordingForm />

    </div>
    
</template>
    
<script>
import WowzaLivestreamRecordingForm from '@/components/livestream/WowzaLivestreamRecordingForm.vue';

export default {
    components: {
        WowzaLivestreamRecordingForm,
    },
}
</script>

<style lang="scss" scoped></style>